import { render, staticRenderFns } from "./form-generic--input-text-v2.vue?vue&type=template&id=1e706dce&"
import script from "./form-generic--input-text-v2.vue?vue&type=script&lang=ts&"
export * from "./form-generic--input-text-v2.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports